import { GeneralService, ApiKeyOrGetter } from "./GeneralService";

export interface VastAdapter {
  model_id: number;
  model_name: string;
  hosted_name: string;
  company_id: number;
  finetune_run_id: number | null;
  status: string;
}

export interface VastInstance {
  id: number;
  company_id: number;
  provider: string;
  instance_id: string;
  description: string;
  gpu_type: string;
  gpu_count: number;
  base_model: string;
  hf_model_id?: string | null;
  vllm_config?: Record<string, unknown>;
  status: string;
  max_adapter_count: number;
  template_hash_id: string | null;
  date_created: string;
  date_updated: string;
  cost_per_hour: number | null;
  adapter_count: number;
  adapters: VastAdapter[];
}

export class VastInfraService {
  public static getInstances(
    loadingHandler: ((val: boolean) => void) | null,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.get(
      "/admin/vast/instances",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static deleteInstance(
    infraId: number,
    force: boolean,
    loadingHandler: ((val: boolean) => void) | null,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.post(
      `/admin/vast/instances/${infraId}/delete`,
      JSON.stringify({ force }),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static removeAdapter(
    infraId: number,
    modelId: number,
    loadingHandler: ((val: boolean) => void) | null,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.delete(
      `/admin/vast/instances/${infraId}/adapters/${modelId}`,
      JSON.stringify({}),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
}
